(ns app.front.view.meeting.meeting-subs
  (:require [app.front.entities :as entities]
            [app.front.view.meeting.meeting-events :as meeting-events]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))


(defn- entity-to-map [entity]
  (-> (fn [acc [key val]] (assoc acc key val))
      (reduce {} entity)
      (assoc :db/id (:db/id entity))))


(defn- update-frontend-datetime-fields
  "Backend uses two instants for the meeting start and end time.
  The frontend uses separate pickers for the date and times.
  Also changes the meeting entity into a plain map for editing"
  [{:meeting/keys [start end] :as meeting}]
  (merge (entity-to-map meeting)
         {:date  start
          :start [(some-> start .getHours) (some-> start .getMinutes)]
          :end   [(some-> end .getHours) (some-> end .getMinutes)]}))


(rf/reg-sub
  ::meetings
  (fn [_ [_ parent-id]]
    (->> (<sub [::entities/entities {:entity/type   :entity.type/meeting
                                     :entity/parent parent-id}])
         (map update-frontend-datetime-fields))))


(rf/reg-sub
  ::expanded?
  (fn [db [_ meeting-id]]
    (boolean (get-in db [::meeting-events/meetings meeting-id :expanded?]))))
